import {
	LOAD_INSPECTION,
	UNLOAD_INSPECTION,
	UPDATE_CURRENT_INSPECTION,
	UPDATE_CURRENT_REMOTE_INSPECTION,
	UPDATE_CURRENT_INSPECTION_ERROR,
	COMPLETE_INSPTECTION,
	COMPLETE_INSPTECTION_ERROR,
	LOAD_REMOTE_INSPECTION
} from "../actions/inspection.js";
import { UPDATE_PAGE } from "../actions/app.js";

const initialState = {
	items: [],
	loading: false,
	error: null
};

export default function inspectionReducer(state = initialState, action) {
	switch (action.type) {
		case UPDATE_PAGE:
			if (action.route.page !== "inspection" && action.route.page != "remote-inspection")
				return { ...state, remote: null, inspection: null };
			else return { ...state };
		case LOAD_REMOTE_INSPECTION:
			return { ...state, remote: action.data, inspection: null }
		case LOAD_INSPECTION:
			return { ...state, current: action.inspection, remote: null, prevInspId: action.inspection._key };
		case UNLOAD_INSPECTION:
			return { ...state, current: undefined, remote: null };
		case UPDATE_CURRENT_INSPECTION:
			if (state.current && action.key == state.current._key) {
				return { ...state, ...{ current: action.changeObj, remote: null } };
			}
			return state;
		case UPDATE_CURRENT_REMOTE_INSPECTION:		  
			let r = { ...state, ...{  current: null } };		  
			r.remote.inspection = action.changeObj ;
			return r;
		case UPDATE_CURRENT_INSPECTION_ERROR:
			return state; //TODO: implement later

		case COMPLETE_INSPTECTION:
			if (action.key == state.current._key) {
				return { ...state, ...{ current: action.changeObj }, remote: null };
			}

			return state;
		case COMPLETE_INSPTECTION_ERROR:
			return state; //TODO: implement later

		default:
			return state;
	}
}
